import React, { useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { listOptions, listLabel } from "../utils/i18nOptions";
import AvatarImg from "./AvatarImg";
import AvatarPreviewModal from "./AvatarPreviewModal";
import useBodyScrollLock from "../hooks/useBodyScrollLock";

function UyeModal({
  seciliUye,
  setSeciliUye,
  yasHesapla,
  yoneticiMi,
  uyeRolDegistir,
  uyeYetkiDegistir,
  uyeyiAiledenCikar,
  ownerUid,
}) {
  const { t, tList, lang } = useLanguage();
  const [avatarPreviewOpen, setAvatarPreviewOpen] = useState(false);
  useBodyScrollLock(true);
  const roller = listOptions(tList, "const.roles");
  const aileYetkileri = listOptions(tList, "const.familyAuthorities");
  const memberName = `${seciliUye.ad || ""} ${seciliUye.soyad || ""}`.trim() || t("family.member");
  const memberInitials = `${seciliUye.ad?.[0] || ""}${seciliUye.soyad?.[0] || ""}` || "?";
  const profileRole = listLabel(tList, "const.roles", seciliUye.rol) || t("family.member");
  const familyAuthority = listLabel(tList, "const.familyAuthorities", seciliUye.aileYetkisi || "Aile Üyesi");
  const age = yasHesapla(seciliUye.dogumTarihi);
  const detailItems = [
    { icon: "@", label: t("member.username"), value: seciliUye.kullaniciAdi },
    { icon: "✉", label: t("member.email"), value: seciliUye.email },
    { icon: "☎", label: t("member.phone"), value: seciliUye.telefon },
    { icon: "◷", label: t("member.birthDate"), value: seciliUye.dogumTarihi },
  ].filter((item) => String(item.value || "").trim());

  return (
    <div className="modalOverlay uyeProfileOverlay" onClick={() => setSeciliUye(null)}>
      <div className="modalCard uyeDetayModalDark" role="dialog" aria-modal="true" aria-labelledby="uye-profile-name" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="uyeProfileClose" onClick={() => setSeciliUye(null)} aria-label={t("common.close")}>×</button>

        <div className="uyeProfileHero">
          <button
            type="button"
            className="uyeAvatarPreviewButton"
            onClick={() => setAvatarPreviewOpen(true)}
            aria-label={lang === "en" ? `View ${memberName}'s avatar` : `${memberName} avatarını görüntüle`}
          >
            <AvatarImg
              avatar={seciliUye.avatar || null}
              renk={seciliUye.calendarColor || "#6366f1"}
              initials={memberInitials}
              size={58}
              glow
            />
            <span className="avatarPreviewBadge" aria-hidden="true">⌕</span>
          </button>
          <div className="uyeProfileIdentity">
            <span className="uyeProfileEyebrow">{t("member.role")}</span>
            <h2 id="uye-profile-name">{memberName}</h2>
            <div className="uyeProfileBadges">
              <span className="uyeProfileBadge primary">{profileRole}</span>
              <span className="uyeProfileBadge">{familyAuthority}</span>
            </div>
          </div>
        </div>

        <div className="uyeProfileQuickFacts">
          <div><span>{t("member.age")}</span><b>{age ?? "—"}</b></div>
          <div><span>{t("member.gender")}</span><b>{listLabel(tList, "const.genders", seciliUye.cinsiyet) || "—"}</b></div>
          <div><span>{t("member.familyAuthority")}</span><b>{familyAuthority || "—"}</b></div>
        </div>

        {detailItems.length > 0 && (
          <div className="uyeProfileDetails">
            {detailItems.map((item) => (
              <div className="uyeProfileDetail" key={item.label}>
                <span className="uyeProfileDetailIcon" aria-hidden="true">{item.icon}</span>
                <div><small>{item.label}</small><strong>{item.value}</strong></div>
              </div>
            ))}
          </div>
        )}

        {yoneticiMi && (
          <div className="uyeProfileAdminPanel">
            <div className="uyeProfileAdminTitle"><span aria-hidden="true">◇</span>{t("member.changeRole")}</div>
            <div className="uyeProfileSelectGrid">
              <label>
                <span>{t("member.role")}</span>
                <select value={seciliUye.rol} onChange={(e) => uyeRolDegistir(seciliUye.uid, e.target.value)}>
                  {roller.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </label>
              <label>
                <span>{t("member.familyAuthority")}</span>
                <select value={seciliUye.aileYetkisi || "Aile Üyesi"} onChange={(e) => uyeYetkiDegistir(seciliUye.uid, e.target.value)}>
                  {aileYetkileri.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </label>
            </div>
          </div>
        )}

        <div className="uyeProfileActions">
          {yoneticiMi && seciliUye.uid !== ownerUid && (
            <button type="button" className="uyeProfileRemove" onClick={() => uyeyiAiledenCikar(seciliUye)}>{t("member.removeFromFamily")}</button>
          )}
          <button type="button" onClick={() => setSeciliUye(null)} className="uyeProfileDone">{t("common.close")}</button>
        </div>
      </div>

      <AvatarPreviewModal
        open={avatarPreviewOpen}
        onClose={() => setAvatarPreviewOpen(false)}
        avatar={seciliUye.avatar || null}
        renk={seciliUye.calendarColor || "#6366f1"}
        initials={memberInitials}
        title={lang === "en" ? `${memberName}'s avatar` : `${memberName} avatarı`}
        closeLabel={t("common.close")}
      />
    </div>
  );
}

export default UyeModal;
